var map = {
	"./balloons.png": 534,
	"./balloons_responsive.png": 535,
	"./blobs.png": 536,
	"./blobs_responsive.png": 537,
	"./cleaning.png": 538,
	"./cleaning_responsive.png": 539,
	"./constellations.png": 540,
	"./constellations_responsive.png": 541,
	"./guess_what.png": 542,
	"./guess_what_responsive.png": 543,
	"./memory.png": 544,
	"./memory_responsive.png": 545,
	"./memoseq.png": 546,
	"./memoseq_responsive.png": 547,
	"./pianoseq.png": 548,
	"./pianoseq_responsive.png": 549,
	"./place_it.png": 550,
	"./place_it_responsive.png": 551,
	"./potpourri.png": 552,
	"./potpourri_responsive.png": 553,
	"./quality_control.png": 554,
	"./quality_control_responsive.png": 555,
	"./shopping.png": 556,
	"./shopping_responsive.png": 557,
	"./twister.png": 558,
	"./twister_responsive.png": 559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 533;